// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "b536a0f1" + "." + "7bca440af1708a0f" + ".js";
};